{
  "signUpFree": "Sign Up Free",
  "firstName": "First Name",
  "lastName": "Last Name",
  "Email": "Email",
  "Password": "Password",
  "ConfirmPassword": "Confirm Password",
  "PrivacyPolicy": "privacy policy",
  "required": "Required",
  "Signup": "Sign Up",
  "*required": "*required",
  "InvalidEmail": "Invalid email address",
  "InvalidCharacters": "Contains invalid characters. Please use only letters, spaces, hyphens (-), apostrophes ('), and periods (.)",
  "UnableToAcceptInvitation": "You will not be able to accept the invitation using this email address.",
  "PasswordMinLength": "Password must be at least 6 characters long",
  "PasswordDoesNotMatch": "Password does not match",

  "SignUpConsent1Part1": "I consent to the usage of cookies, collection and processing of data by RebelBase, transmission of data to the United States.",
  "SignUpConsent1Part2": "For details regarding how we protect your personal data, please see our ",

  "Cookies": "Cookies",
  "CookiesConsent": "RebelBase utilizes cookies to keep user preferences and improve user experience.",

  "DataCollection": "Collection and processing of data",
  "DataCollectionConsent": "RebelBase processes personal data to provide services on the platform.",

  "DataTransmission": "Transmission of data to the US",
  "DataTransmissionConsent": "RebelBase is a US company. To provide services to you, we will securely transfer personal data to the United States.",

  "forMoreInfo": "For more info, please see",

  "SignUpConsent2": "I consent to receiving promotional email updates from RebelBase. RebelBase may send customers email updates to ask your opinion with a survey or marketing communications. Unsubscribe anytime.",
  "Optional": "Optional",

  "agree": "By signing up, you agree to our ",
  "terms": "terms of service.",
  "signedUp?": "Already signed up?",
  "Login": "Login",
  "getStarted": "Get Started",

  "see": "See",

  "readMore": "read more",

  "EnterValidEmail": "Please enter a valid email."
}
